/* Elemence Bundles — carousel prev/next nav.
   Mirrors React: scrollByCard scrolls by card width + gap, updateNav
   disables prev/next at the edges. */
(function () {
  function initCarousel(root) {
    if (!root || root.dataset.bundlesInit === '1') return;
    root.dataset.bundlesInit = '1';

    const track = root.querySelector('.elemence-bundles__track');
    const prev  = root.querySelector('.elemence-bundles__nav--prev');
    const next  = root.querySelector('.elemence-bundles__nav--next');
    if (!track) return;

    const updateNav = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    };

    const scrollByCard = (dir) => {
      const card = track.querySelector('.elemence-bundle');
      const step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.5;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => scrollByCard(-1));
    if (next) next.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  function initAll(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.elemence-bundles').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
